import { Fragment } from 'react'
import PropTypes from 'prop-types'
import InfiniteScroll from '../../infinite-scroll/InfiniteScroll'

import { ReactComponent as OutsideLinkIcon } from '../../../assets/images/common/icons/outside-link-icon.svg'
import StudentWithAvatar from '../../students/StudentWithAvatar'

import classes from './StudentsTable.module.scss'
import { calculateAge, genderLabel } from '../../../utility/userHelper'
import Loader from '../../common/loader/Loader'
import classNames from 'classnames'
import moment from 'moment'


const StudentsTable = ({ students, fetchData, pagination, onStudentClick, inspectedStudentId }) => {
  const hasMore = !pagination?.totalPages || (pagination?.page + 1) <= pagination?.totalPages

  if (!students || !pagination) {
    return (
      <div className='h-100 d-flex align-items-center justify-content-center'>
        <Loader>Loading Students</Loader>
      </div>
    )
  }

  return (
    <div id='studentsTable' className={classes.table}>
      <InfiniteScroll
        dataLength={students.length}
        next={fetchData}
        hasMore={hasMore}
        scrollableTarget='tableContent'
        className={classes.tableContent}
        hideLoader
      >
        <div className={classes.gridTable} id='tableContent'>
          <div className={classNames(classes.col, classes.header, classes.firstColumn, classes.topLeft)}>
            <span>Student</span>
          </div>
          <div className={classNames(classes.col, classes.header)}>
            <span>Years in Community</span>
          </div>
          <div className={classNames(classes.col, classes.header)}>
            <span>Enrollment Status</span>
          </div>
          <div className={classNames(classes.col, classes.header)}>
            <span>Total Enrollments</span>
          </div>
          <div className={classNames(classes.col, classes.header)}>
            <span>Total Revenue</span>
          </div>
          <div className={classNames(classes.col, classes.header)}>
            <span>Strokes Lost</span>
          </div>
          <div className={classNames(classes.col, classes.header)}>
            <span>9HE Rounds</span>
          </div>
          <div className={classNames(classes.col, classes.header)}>
            <span>Casual Rounds</span>
          </div>
          <div className={classNames(classes.col, classes.header)}>
            <span>Practice Sessions</span>
          </div>
          <div className={classNames(classes.col, classes.header)}>
            <span>Time Practiced</span>
          </div>

          {students.map(student => (
            <Fragment key={student.id}>
              <div
                tabIndex={0}
                role='button'
                onKeyDown={() => null}
                className={
                  classNames(classes.col, classes.firstColumn, classes.studentInfo, { [classes.isClicked]: student.id === inspectedStudentId })
                }
                title={`${student.firstName} ${student.lastName}`}
                onClick={() => onStudentClick(student)}
              >
                <StudentWithAvatar student={student} avatarClassName='small-round-image-wrapper' />
                <div className='d-flex flex-column flex-grow-1 pr-3'>
                  <h6 className='mb-1 font-weight-bold'>{student.firstName} {student.lastName}</h6>
                  <span>
                    {student.birthdate !== null && `${calculateAge(student.birthdate)}yrs / `}
                    {genderLabel[student.gender]}
                  </span>
                </div>
                <OutsideLinkIcon className={classes.detailsIcon} />
              </div>

              <div className={classes.col}>
                <span className='font-weight-bold'>{student.firstActivity ? moment(student.firstActivity).fromNow(true) : '-'}</span>
              </div>

              <div className={classes.col}>
                <span
                  className={classNames({ [classes.enrollmentActive]: student.enrollmentStatus === 'active' })}
                >
                  {student.enrollmentStatus === 'active' ? 'Active (View Program)' : 'Inactive (No Program)'}
                </span>
              </div>

              <div className={classes.col}>
                <span className='font-weight-bold'>{student.enrollments?.length || 0}</span>
              </div>

              <div className={classes.col}>
                <span className='font-weight-bold'>${student.totalRevenue}</span>
              </div>

              <div className={classes.col}>
                <span className='font-weight-bold'>{student.strokesLost}</span>
              </div>

              <div className={classes.col}>
                <span className='font-weight-bold'>{student.nineHoleRounds}</span>
              </div>

              <div className={classes.col}>
                <span className='font-weight-bold'>{student.casualRounds}</span>
              </div>

              <div className={classes.col}>
                <span className='font-weight-bold'>{student.practiceSessions}</span>
              </div>

              <div className={classes.col}>
                <span className='font-weight-bold'>{student.timePracticed} hr</span>
              </div>
            </Fragment>
          ))}
        </div>
      </InfiniteScroll>
    </div>
  )
}

StudentsTable.propTypes = {
  students: PropTypes.array,
  fetchData: PropTypes.func.isRequired,
  onStudentClick: PropTypes.func,
  pagination: PropTypes.object,
  inspectedStudentId: PropTypes.number,
}

export default StudentsTable
